import React from 'react'

const Generic = () => {
    return (
        <div>Smth is coming soon</div>
    )
}

export default Generic